import $ from 'jquery';
export const init = async function() {
    function formatPhone() {
        const text = ($(this).val() || '').toString();
        const num = text.replace(/\D/g, '');
        $(this).val('(' + num.substring(0, 3) + ') ' + num.substring(3, 6) + '-' + num.substring(6, 10));
    }
    $('[type="tel"]').keyup(formatPhone);
};
